import { useInfiniteQuery } from '@tanstack/react-query'
// import type { AllPostsQuery } from 'gql/graphql'
import { getAllPostsPerCat } from 'query/nouvelles'

const usePosts = (queryKey: string, category: string, language: string, after = '', hasNextPage = true) => {
  const postsListingQuery = useInfiniteQuery(
    [`${queryKey}-${category}-${language}`],
    () => getAllPostsPerCat(category, after, language),
    {
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, pages) => {
        if (hasNextPage) {
          return { lastPage, pages }
        }
        return null
      },
    },
  )

  return postsListingQuery
}

export default usePosts
